import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that keeps a pickup-only notice (or its hidden line-item
 * property input) in sync with the selected variant.
 *
 * The pickup-only state lives in a variant metafield that is not part of the
 * variant JSON, so it cannot be read from the variant update event directly.
 * Instead, each instance re-renders itself by morphing from the server-rendered
 * section HTML carried in `event.detail.data.html`, matching its counterpart by id.
 */
class PickupAvailabilityNotice extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');

    /** @type {(event: import('@theme/events').VariantUpdateEvent) => void} */
    const variantUpdated = (event) => {
      const html = event.detail.data.html;
      if (!html || !this.id) return;

      const next = html.getElementById(this.id);
      if (next) morph(this, next);
    };

    closestSection?.addEventListener(ThemeEvents.variantUpdate, variantUpdated);

    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(ThemeEvents.variantUpdate, variantUpdated);
    };
  }
}

if (!customElements.get('pickup-availability-notice')) {
  customElements.define('pickup-availability-notice', PickupAvailabilityNotice);
}
